export default "__VITE_PUBLIC_ASSET__97ae4c22__"